import React from 'react'
import {
    Avatar,
    Badge,
    Button,
    Card,
    Col,
    Divider,
    Empty,
    List,
    Modal,
    Progress,
    Row,
    Space,
    Tag,
    Tooltip,
    Typography
} from 'antd'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/Pieces.less'
import {onPaginationSave} from '../../action/style'
import {getArtistDashboard} from "../../api/artistDashboard";
import {Skeleton} from "antd/es";
import {getBlogs} from "../../api/blogs";
import axios from "axios";
import HttpError from "../../component/base/HttpError";
import {
    URL_AGREEMENTS,
    URL_APPLY_REVART,
    URL_COLLECTIONS,
    URL_CONTACTS,
    URL_EXHIBITIONS,
    URL_INCOME_ORDER,
    URL_INCOME_PAYMENT,
    URL_NEW_COLLECTIONS,
    URL_NEW_EXHIBITIONS,
    URL_NEW_PIECES,
    URL_PIECES,
    URL_SHOWCASE_PUBLISH
} from "../../const";
import {getBlogUrl} from "../../component/Utils";
import {getOpenCalls, getOpenCallsHighlight} from "../../api/openCalls";
import {is_admin_user} from "../../app/role";
import {getArtistsAdmin} from "../../api/artists";
import InviteArtistModal from "../../component/dashboard/InviteArtistModal";
import ArtistsTable from "../../component/dashboard/ArtistsTable";
import {switchArtist} from "../../action/user";
import PiecesTourModal from "../../component/piece/PiecesTourModal";
import DashboardTourModal from "../../component/dashboard/DashboardTourModal";

const {Title, Link} = Typography
const {Meta} = Card;

@connect(
    (state) => ({
        id: state.user.info.id, // real user id, admin_id or artist_id
        token: state.user.info.token, // login user token
        userId: state.user.info.userId, // artist user obj id
        artistId: state.user.info.artistId, // artist obj id
        artistName: state.user.info.artistName,
        email: state.user.info.email,
        admin_email: state.user.info.admin_email, // admin user email
        role: state.user.info.role
    }),
    {
        onPaginationSave,
        switchArtist
    }
)
class Dashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loadingBlogs: false,
            loadingOpenCalls: false,
            loadingArtists: false,
            dashboard: null,
            openCallModalOpen: false,
            openCallModal: null,
            todos: {},
            artists: [],
            openCalls: [],
            subscriptionPlan: 'basic',
            subscriptionHint: null,
            subscriptionDate: null,
            blogs: [1, 2, 3, 4, 5, 6],
            inviteModalOpen: false
        }

        this.todoList = [
            {
                title: 'Apply for RevArt',
                key: 'apply_revart',
                link: URL_APPLY_REVART,
                actions: [<Button type={"link"} href={URL_APPLY_REVART}>Apply</Button>]
            },
            {
                title: 'Create first piece',
                key: 'first_piece',
                link: URL_NEW_PIECES,
                actions: [<Button type={"link"} href={URL_NEW_PIECES}>Create</Button>]
            },
            {
                title: 'Create first collection',
                key: 'first_collection',
                link: URL_NEW_COLLECTIONS,
                actions: [<Button type={"link"} href={URL_NEW_COLLECTIONS}>Create</Button>]
            },
            {
                title: 'Create first exhibition',
                key: 'first_exhibition',
                link: URL_NEW_EXHIBITIONS,
                actions: [<Button type={"link"} href={URL_NEW_EXHIBITIONS}>Create</Button>]
            },
            {
                title: 'Publish your showcase',
                key: 'showcase_published',
                link: URL_SHOWCASE_PUBLISH,
                actions: [<Button type={"link"} href={URL_SHOWCASE_PUBLISH}>Publish</Button>]
            },
        ];
        if (this.props.role === 'gallery') {
            this.todoList = this.todoList.filter((todo) => (todo.key !== 'apply_revart'))
        }

        this.requestDataToken = axios.CancelToken.source()
        this.search_key = props.location?.search ?? ''
        console.log(this.search_key)
        this.inviteCode = ''
        if (this.search_key) {
            try {
                const keys = this.search_key.split("&")
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i]
                    if (key.startsWith("?invite_code=")) {
                        this.inviteCode = key.replace("?invite_code=", "")
                    }
                }
            } catch (e) {

            }
        }
        console.log(this.inviteCode)
          if (this.inviteCode === 'gallery') {
             window.location.href='https://airtable.com/appJS60NmJ0bqHXJe/pagwxPfewdH3jYF0P/form'
        }
    }

   get_detail_link(call) {
        const url = "https://revart.co/opencalls/"+getBlogUrl(call.id, call.title)
        return url
    }

    componentWillUnmount() {
        if (this.state.loading || this.state.loadingBlogs) {
            if (this.requestDataToken && this.requestDataToken.cancel)
                this.requestDataToken.cancel("cancel")
            this.setState({
                loading: false
            })
        }
    }

    componentDidMount() {
        if (!this.props.artistId) return
        this.setState({
            loading: true,
        })
        getArtistDashboard(this.props.artistId, this.requestDataToken).then((res) => {
            this.setState({
                dashboard: res.data
            })
            let s0 = res.data.revart_status === 'Not applied' ? 0 : 1
            let s1 = res.data.total_pieces > 0 ? 1 : 0
            let s2 = res.data.total_collections > 0 ? 1 : 0
            let s3 = res.data.total_exhibitions > 0 ? 1 : 0
            let s4 = res.data.showcase_status === 'published' ? 1 : 0

            if (res.data?.subscription_status) {
                if (res.data.subscription_expired_at) {
                    const expirationDate = new Date(res.data.subscription_expired_at);
                    const options = {year: 'numeric', month: 'long', day: 'numeric'};
                    const expirationDateString = expirationDate.toLocaleDateString('en-US', options);
                    this.setState({
                        subscriptionDate: expirationDateString
                    })
                }
                if (res.data.subscription_hints && res.data.subscription_hints === 'revart_artist_2023') {
                    this.setState({
                        subscriptionHints: "One-year credits have been applied for RevArt artists",
                    })

                }
                this.setState({
                    subscriptionPlan: res.data.subscription_status,
                })
            }

            // open calls
            if (this.props.role !== 'gallery') {
                this.setState({
                    loadingOpenCalls: true
                })
                const calls = []
                const filterResult = []
                let promises = [getOpenCallsHighlight(0, 3, this.requestDataToken),
                                              getOpenCalls(0, 3, this.requestDataToken)]
                Promise.all(promises).then((res)=>{

                    if (res[0]){
                        res[0].data?.results?.forEach((call) => {
                            calls.push(call)
                        })
                    }
                    if (res[1]) {
                        res[1].data?.results?.forEach((call) => {
                            calls.push(call)
                        })
                    }
                    const processedcalls = new Set(); // Create a Set to store processed invite codes
                    calls.forEach((call)=>{
                        if (!call.is_display) return;
                        if (call.invite_code === "revartprogram" && this.state.todos.apply_revart) {
                            return
                        }
                         if (call.title && processedcalls.has(call.title)) {
                            return; // Skip processing if it's a duplicate
                        }
                        if (call.is_display && call.invite_code && this.inviteCode?.startsWith(call.invite_code)) {
                            this.setState({
                                openCallModalOpen: true,
                                openCallModal: {
                                    title: call.title,
                                    link: call.apply_link,
                                    body: call.body,
                                },
                            })
                        }
                        filterResult.push(call)
                        processedcalls.add(call.title)
                    })
                    this.setState({
                        openCalls: filterResult
                    })
                }).catch((error) => {
                    if (axios.isCancel(error)) {
                        return
                    }
                    HttpError(error)
                }).finally(() => {
                    this.setState({
                        loadingOpenCalls: false
                    })
                })
            }

            let todos = {}
            let todoSteps = 0
            let todoPercent = 0

            if (this.props.role === 'gallery') {
                todos = {
                    ...this.state.todos,
                    first_piece: s1 ?? false,
                    first_collection: s2 ?? false,
                    first_exhibition: s3 ?? false,
                    showcase_published: s4 ?? false,
                }
                todoSteps = 4
                todoPercent = (s1 + s2 + s3 + s4) / todoSteps * 100
            } else {
                todos = {
                    ...this.state.todos,
                    apply_revart: s0 ?? false,
                    first_piece: s1 ?? false,
                    first_collection: s2 ?? false,
                    first_exhibition: s3 ?? false,
                    showcase_published: s4 ?? false,
                }
                todoSteps = 5
                todoPercent = (s0 + s1 + s2 + s3 + s4) / todoSteps * 100
            }

            this.setState({
                todos: todos,
                todoSteps: todoSteps,
                todoPercent: todoPercent
            })
        }).catch((error) => {
            if (axios.isCancel(error)) {
                return
            }
            HttpError(error)
        }).finally(() => {
            this.setState({
                loading: false
            })
        })

        // blogs
        if (this.props.role !== 'gallery') {
            this.setState({loadingBlogs: true})
            getBlogs(0, 3, this.requestDataToken).then((res) => {
                this.setState({
                    blogs: res.data.results
                })
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    return
                }
                HttpError(error)
            }).finally(() => {
                this.setState({
                    loadingBlogs: false
                })
            })
        }
    }

    onDataUpdate = (data) => {
        this.setState({
            rawData: data
        })
    }

    getStatsNumCard = (title, value, url) => {
        if (this.state.loading) {
            return (
                <Col xs={24} sm={8}>
                    <Skeleton/>
                </Col>
            )
        }
        return (
            <Col xs={24} sm={8}>
                {}
                <Card bordered={true} style={{boxShadow: "none !important;", minHeight: 107}}>
                    <Typography style={{fontSize: 12}}>{title}</Typography>
                    <Link href={url}>
                        <Typography
                            style={{fontSize: 20, fontWeight: "bold", marginTop: 12}}>{value}</Typography>
                    </Link>
                </Card>
            </Col>
        )
    }

    getStatsStatusCard = (title, value, date, msg, link) => {
        if (this.state.loading) {
            return (
                <Col xs={24} sm={8}>
                    <Skeleton/>
                </Col>
            )
        }

        const getDate = () => {
            if (date) {
                return <span style={{fontSize: 10}}>{" (until " + date + ")"}</span>
            } else {
                return null
            }
        }

        const getTag = () => {
            if (msg) {
                return (
                    <Tooltip placement="top" title={msg}>
                        <Tag>{value}</Tag>
                        {getDate()}
                    </Tooltip>
                )
            } else {
                return (<><Tag>{value}</Tag>{getDate()}</>)
            }
        }

        const getLink = () => {
            if (link) {
                return (
                    <Link href={link}>
                        <Typography
                            style={{fontSize: 20, marginTop: 5}}>
                            {getTag()}
                        </Typography>
                    </Link>
                )
            } else {
                return (
                    <Typography
                        style={{fontSize: 20, marginTop: 5}}>
                        {getTag()}
                    </Typography>
                )
            }
        }

        return (
            <Col xs={24} sm={8}>
                <Card bordered={true} style={{boxShadow: "none !important;"}}>
                    <Typography style={{fontSize: 12}}>{title}</Typography>
                    {getLink()}
                </Card>
            </Col>
        )
    }

    getBlogDetailUrl(id, name) {
        return 'https://revart.co/blogs/' + getBlogUrl(id, name)
    }

    getOpenCallModal() {
        return (
            <Modal
                open={this.state.openCallModalOpen}
                title={this.state.openCallModal?.title}
                onOk={() => {
                    this.setState({
                        openCallModalOpen: false
                    })
                }}
                onCancel={() => {
                    this.setState({
                        openCallModalOpen: false
                    })
                }}
                footer={[
                    <Button key="submit" type="primary" onClick={() => {
                        window.location.href = this.state.openCallModal?.link
                    }}>
                        Apply now
                    </Button>,
                ]}
            >
                <div style={{maxHeight: '60vh', overflowY: "auto"}}>
                    <div dangerouslySetInnerHTML={{__html: this.state.openCallModal?.body}}/>
                </div>
            </Modal>
        )
    }

    getOpenCall() {
        const contentStyle = {
            width: 320,
            maxWidth: '92%',
            height: 490,
        }
        const buttonStyle = {
            width: '90%',
            float: 'right', bottom: 42, position: 'absolute', right: '5%', left: '5%'
        }

                const buttonStyle2 = {
            width: '90%',
            float: 'right', bottom: 0, position: 'absolute', right: '5%', left: '5%'
        }
        const getCard = (call) => {
            return (
                <Card
                    style={contentStyle}
                    cover={<img style={{width: '100%', height: 320}} alt="example" src={call.thumbnails}/>}
                >
                    <Meta title={call.title} description={call.description}/>
                    {call.body && (
                        <Button style={buttonStyle} onClick={() => {
                            this.setState({
                                openCallModalOpen: true,
                                openCallModal: {
                                    title: call.title,
                                    link: call.apply_link,
                                    body: call.body,
                                }
                            })
                        }}>Apply</Button>
                    )}
                    {!call.body && call.apply_link && (
                        <Button style={buttonStyle} onClick={() => {
                            window.location.href = call.link
                        }}>
                            Apply

                        </Button>
                    )}
                        <Button style={buttonStyle2} href={this.get_detail_link(call)} target={'_blank'} type="link">
                        View details
                    </Button>
                </Card>
            )
        }
        const getDeadlineMessage = (deadline) => {

            try {
                const now = new Date();

                // Calculate the difference in milliseconds between the deadline and now
                const diff = new Date(deadline).getTime() - now.getTime();

                // Convert the difference to days
                const daysLeft = Math.ceil(diff / (1000 * 60 * 60 * 24));
                return `${daysLeft} days left`
            } catch (e) {
                return ""
            }

        }

        if (!this.state.openCalls || this.state.openCalls.length === 0) {
            return <Empty/>
        }

        return (
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 24}}>
                {this.getOpenCallModal()}
                {this.state.openCalls.map((call, index) => {
                    if (index >= 6) return
                    if (this.state.loadingOpenCalls) {
                        return <>
                            <Skeleton style={contentStyle}/>
                            <Skeleton style={contentStyle}/>
                        </>
                    }
                    if (call === 1) return null
                    return (
                        <>
                            {call.expired_at && (
                                <Badge.Ribbon text={getDeadlineMessage(call.expired_at)}>
                                    {getCard(call)}
                                </Badge.Ribbon>
                            )}
                            {!call.expired_at && (
                                <div>
                                    {getCard(call)}
                                </div>
                            )}
                        </>
                    )
                })}
            </div>
        )
    }

    getArtists() {
        return <ArtistsTable {...this.props}/>
    }

    isRevArtArtist() {
        return this.props.role !== 'gallery' && this.state.dashboard?.is_revart_artist
    }

    render() {
        return (
            <div className='site-layout-background' style={{background: "#f1f1f1"}}>
                <DashboardTourModal id={this.props.id} role={this.props.role}/>
                <Title level={2} style={{
                    fontSize: 16,
                    color: 'black',
                    marginTop: 12,
                    marginBottom: 12
                }}>Welcome {this.props.artistName ?? this.props.email}!</Title>
                <Row align='middle' gutter={[{xs: 8, sm: 8, md: 8}, {xs: 8, sm: 8, md: 8}]} style={{marginTop: 24}}>
                    {is_admin_user(this.props) && !this.props.artistId && (
                        <Col xs={24} xxl={20}>
                            <InviteArtistModal open={this.state.inviteModalOpen} onClose={() => {
                                this.setState({
                                    inviteModalOpen: false
                                })
                            }}/>
                            <Card style={{borderRadius: 12}}>
                                <div style={{display: 'flex', alignItems: 'baseline', flexDirection: 'row'}}>
                                    <Title level={5} style={{marginBottom: 0, color: 'black'}}>Artists
                                    </Title>
                                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12}}
                                            onClick={() => {
                                                this.setState({inviteModalOpen: true})
                                            }}>Invite</Button>
                                </div>
                                <Divider/>
                                {this.getArtists()}
                            </Card>
                        </Col>
                    )}

                    {this.isRevArtArtist() && (
                        <Col xs={24} xxl={20}>
                            <Card style={{borderRadius: 12}}>
                                <Title level={5} style={{marginBottom: 0, color: 'black'}}>Open Calls</Title>
                                <Divider/>
                                {this.getOpenCall()}
                                    <center><Button type={'primary'} onClick={() => {
                                    window.location.href = 'https://revart.co/opencalls/'
                                }}>View more</Button></center>
                            </Card>
                        </Col>
                    )}

                    <Col xs={24} xxl={20}>
                        <Card style={{borderRadius: 12}}>
                            <Title level={5} style={{marginBottom: 0, color: 'black'}}>Analytics</Title>
                            <Divider/>
                            <Typography style={{fontSize: 12, color: 'black'}}>Your key stats:</Typography>
                            <Row gutter={[4, 4]} style={{marginTop: 24}}>
                                {this.getStatsNumCard('Pieces', this.state.dashboard?.total_pieces, URL_PIECES)}
                                {this.getStatsNumCard('Collections', this.state.dashboard?.total_collections, URL_COLLECTIONS)}
                                {this.getStatsNumCard('Exhibitions', this.state.dashboard?.total_exhibitions, URL_EXHIBITIONS)}
                                {this.getStatsStatusCard('Showcase Status', this.state.dashboard?.showcase_status, null, null, URL_SHOWCASE_PUBLISH)}
                                {this.getStatsNumCard('Orders', this.state.dashboard?.total_orders, URL_INCOME_ORDER)}
                                {this.getStatsNumCard('Payments', this.state.dashboard?.total_payments, URL_INCOME_PAYMENT)}
                                {this.getStatsNumCard('Agreements', this.state.dashboard?.total_agreements, URL_AGREEMENTS)}
                                {this.getStatsNumCard('Contacts', this.state.dashboard?.total_contacts, URL_CONTACTS)}
                                {this.getStatsStatusCard('Subscription Plan', this.state.subscriptionPlan,
                                    this.state.subscriptionDate,
                                    this.state.subscriptionHints)}
                            </Row>
                        </Card>
                    </Col>
                    <Col xs={24} xxl={20}>
                        <Card style={{borderRadius: 12}}>
                            <Space align={'center'} size={[32, 32]}>
                                <Title level={5} style={{marginBottom: 0, color: 'black'}}>Onboarding
                                    Checklist</Title>
                                <Progress percent={this.state.todoPercent} steps={this.state.todoSteps}
                                          style={{width: '100%'}}/>
                            </Space>
                            <Divider/>
                            <List
                                itemLayout="horizontal"
                                dataSource={this.todoList}
                                renderItem={(item, index) => (
                                    <List.Item
                                        actions={item.actions}
                                    >
                                        <List.Item.Meta
                                            avatar={<Avatar
                                                src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`}/>}
                                            title={<a href={item.link} style={{
                                                fontSize: 16, fontWeight: "bold",
                                                textDecoration: this.state.todos[item.key] ? "line-through" : "none"
                                            }}>{item.title}</a>}
                                        />
                                    </List.Item>
                                )}
                            />

                        </Card>
                    </Col>

                    {this.isRevArtArtist()  && (
                        <Col xs={24} xxl={20}>
                            <Card style={{borderRadius: 12}}>
                                <Space align={'center'} size={[32, 32]}>
                                    <Title level={5} style={{marginBottom: 0, color: 'black'}}>Latest Posts</Title>
                                </Space>
                                <Divider/>
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 24}}>
                                    {this.state.blogs.map((blog, index) => {
                                        if (index >= 6) return
                                        if (this.state.loadingBlogs) {
                                            return <Skeleton style={{width: 320, maxWidth: '92%', height: 480}}/>
                                        }

                                        return (
                                            <Card
                                                style={{
                                                    width: 320,
                                                    maxWidth: '92%',
                                                    height: 480,
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                                cover={
                                                    <a href={this.getBlogDetailUrl(blog.id, blog.title)}
                                                       target={'_blank'}
                                                       rel={'noreferrer'}>
                                                        <img
                                                            alt={blog.title}
                                                            src={blog.thumbnails}
                                                            style={{width: 320, height: 240, objectFit: 'cover'}}
                                                        />
                                                    </a>
                                                }
                                                actions={[
                                                    <a href={this.getBlogDetailUrl(blog.id, blog.title)}
                                                       target={'_blank'}
                                                       rel={'noreferrer'}>
                                                        View
                                                    </a>,
                                                ]}
                                            >
                                                <Meta
                                                    title={<h4 style={{height: 32}}>{blog.title}</h4>}
                                                    description={<p
                                                        style={{height: 84}}>{blog.desc?.substring(0, 58)}</p>}
                                                />
                                            </Card>
                                        )
                                    })}
                                </div>
                                <center><Button type={'primary'} onClick={() => {
                                    window.location.href = 'https://revart.co/blogs/'
                                }}>View more</Button></center>
                            </Card>
                        </Col>
                    )}
                </Row>
            </div>
        )
    }
}

export default withRouter(Dashboard)
